import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnErrorsActions, httpRequestsOnLoadActions, httpRequestsOnSuccessActions } from 'store';
import { invoiceTxnService } from './invoiceTxn.service';
import { CREATE_INVOICE_TXN, VOID_INVOICE_TXN, GET_INVOICE_TXNS, GET_INVOICE_TXNS_SUCCESS } from './invoiceTxn.type';
import { GET_INVOICE_BY_ID, GET_INVOICE_BY_ID_SUCCESS } from '../invoice/invoice.type';
import { invoiceService } from '../invoice/invoice.service';

function* createInvoiceTxn(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(invoiceTxnService.createInvoiceTxnService, action.payload.invoiceId, action.payload.body);
        yield put({ type: GET_INVOICE_BY_ID, payload: { id: action.payload.invoiceId } });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* voidInvoiceTxn(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(invoiceTxnService.voidInvoiceTxnService, action?.payload?.txnId, action?.payload?.body);
        if(action?.payload?.reqParams && action?.payload?.invoiceId){
            const res = yield call(invoiceTxnService.getInvoiceTxnsService, action.payload.invoiceId, action.payload.params);
            yield put({
                type: GET_INVOICE_TXNS_SUCCESS,
                payload: res.data,
            });
        }
        if (action?.payload?.invoiceId) {
            const invoiceRes = yield call(invoiceService.getInvoiceByIdService, action.payload.invoiceId);
            yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            yield put({
                type: GET_INVOICE_BY_ID_SUCCESS,
                payload: { invoiceById: invoiceRes?.data },
            });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getInvoiceTxns(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(invoiceTxnService.getInvoiceTxnsService, action.payload.invoiceId, action.payload.params);
        yield put({
            type: GET_INVOICE_TXNS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

export const watchInvoiceTxn = function* watchInvoiceTxnSaga() {
    yield takeLatest(CREATE_INVOICE_TXN, createInvoiceTxn);
    yield takeLatest(VOID_INVOICE_TXN, voidInvoiceTxn);
    yield takeLatest(GET_INVOICE_TXNS, getInvoiceTxns);
};
